// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mine-view{padding-bottom:3.125rem;font-family:Arial,Helvetica,\"sans-serif\"}.mine-view .user-info{background:#fff;font-size:1.125rem}.mine-view .mine-grid .van-grid-item .van-grid-item__text{font-size:1.125rem}.mine-view .user-info .login-button{line-height:1.5rem}", ""]);
// Exports
module.exports = exports;
